// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"rCvb7P_n","firstPages":"aWgX8hl_","swiperIcon":"__1s_0p548","item":"U1KHdAYL","active":"oMc39OW8","listWrap":"__2WI67AAZ","text":"__9cHHjbMp","pagination":"fctheXQ5"};